'use client';

import type { GetCurationsMeServiceResponse, MyCurationItem } from '@musinsa/services-curator';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { curatorQueries } from '../../query-factory';

interface Props {
  size?: number;
  /** 무신사 마이샵 탭(상품/스냅) 필터 — 미전달 시 전체 */
  type?: 'GOODS' | 'SNAP2';
  /** 최상단 노출(pinned)할 큐레이션 ID */
  curationId?: string;
}

export const useMyCurationsInfiniteQuery = ({ size = 5, type, curationId }: Props) => {
  const query = useInfiniteQuery({
    ...curatorQueries.curations.myList({
      size,
      ...(type !== undefined ? { type } : {}),
      ...(curationId !== undefined ? { curationId } : {}),
    }),
    initialPageParam: 1,
    getNextPageParam: (lastResponse: GetCurationsMeServiceResponse) =>
      lastResponse.pagination.hasNextPage ? lastResponse.pagination.nextPage : undefined,
  });

  const flattenedData: MyCurationItem[] = useMemo(
    () => query.data?.pages.flatMap((page) => page.list) ?? [],
    [query.data],
  );

  return {
    ...query,
    products: flattenedData,
  };
};
